import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    errorMessage: (count?) => string | React.ReactNode;
    deleteLoading: (count?) => string | React.ReactNode;
    deleteSuccess: (count?) => string | React.ReactNode;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            errorMessage: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (count = 0) => __intl__.intl().formatMessage({ id: "useDeleteAssets.errorMessage?c=1wb2ot21wzk78", defaultMessage: "{count, plural, one {Couldn''t delete asset} other {Couldn''t delete {count} assets}}" }, { count: count }));
                },
                enumerable: true,
                configurable: true
            },
            deleteLoading: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (count = 0) => __intl__.intl().formatMessage({ id: "useDeleteAssets.deleteLoading?c=m6eki8afceal", defaultMessage: "{count, plural, one {Deleting Asset\u2026} other {Deleting {count} Assets\u2026}}" }, { count: count }));
                },
                enumerable: true,
                configurable: true
            },
            deleteSuccess: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (count = 0) => __intl__.intl().formatMessage({ id: "useDeleteAssets.deleteSuccess?c=2il7m5z3zm0mn", defaultMessage: "{count, plural, one {Asset deleted} other {{count} Assets deleted}}" }, { count: count }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
